import Button from "components/Button";
import Modal from "components/Modal";
import { IconClose } from "icons";
import { ImageWebinar } from "images";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useAppSelector } from "store";
import { hideWebinarModal } from "store/commonSlice";
import { useSiteImage } from "hooks/useSiteImage";

const WEBINAR_URL_EN = "https://us06web.zoom.us/j/81791255381";
const WEBINAR_URL_TR = "https://us06web.zoom.us/j/88226937574";

const WebinarModal = () => {
  const { t } = useTranslation();
  const webinarImage = useSiteImage("campaign.webinar_image", ImageWebinar);
  const dispatch = useDispatch();
  const { showWebinarModal } = useAppSelector((state) => state.common);

  function onClose() {
    dispatch(hideWebinarModal());
  }

  function handleRedirectEN() {
    window.open(WEBINAR_URL_EN, "_blank");
    onClose();
  }

  function handleRedirectTR() {
    window.open(WEBINAR_URL_TR, "_blank");
    onClose();
  }

  return (
    <Modal onClose={onClose} show={showWebinarModal} bodyClassName="bg-black-100 !max-w-[440px] !border-black-300 z-50 !rounded-xl" className="!z-[9999]">
      <button onClick={onClose} className="absolute top-0 right-0 flex-center text-white outline-none" aria-label={t("common:modals.webinar.close_aria")}>
        <IconClose className="w-6 h-6" />
      </button>

      <div className="flex flex-col gap-5 p-5">
        <div className="w-full rounded-lg overflow-hidden">
          <img src={webinarImage} alt={t("common:modals.webinar.image_alt")} className="w-full h-auto object-cover" />
        </div>

        <div className="flex flex-col gap-2">
          <Button className="btn-primary-small focus:outline-none" onClick={handleRedirectEN}>
            <span className="fi fi-gb mr-2"></span> {t("common:modals.webinar.join_en")}
          </Button>
          <Button className="btn-primary-small focus:outline-none" onClick={handleRedirectTR}>
            <span className="fi fi-tr mr-2"></span> {t("common:modals.webinar.join_tr")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default WebinarModal;
